export default "__VITE_ASSET__uFdjrx6B__"